export default __webpack_public_path__ + "static/media/attachment.14c2e649.png";